import { render, staticRenderFns } from "./stock-alert-report.vue?vue&type=template&id=0e5e3944&scoped=true&"
import script from "./stock-alert-report.vue?vue&type=script&lang=js&"
export * from "./stock-alert-report.vue?vue&type=script&lang=js&"
import style0 from "./stock-alert-report.vue?vue&type=style&index=0&id=0e5e3944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e3944",
  null
  
)

export default component.exports